module.exports = __webpack_public_path__ + "img/mentor7.92d1cca.jpg";